import { Link, useLocation } from "react-router-dom";
import { Heart, Users } from "lucide-react";

const CAGNOTTE_LOGO = "https://customer-assets.emergentagent.com/job_fundcollect-1/artifacts/z3sp2s14_logo-sen-cagnotte-1.png";
const NATT_LOGO = "https://customer-assets.emergentagent.com/job_fundcollect-1/artifacts/jdrvfoqw_sen-natt-logo.png";

export function isTontineRoute(pathname) {
  return pathname.startsWith("/tontines");
}

export function useBrand() {
  const location = useLocation();
  const tontine = isTontineRoute(location.pathname);
  return tontine
    ? { name: "Sen Natt", short: "SEN NATT", logo: NATT_LOGO, accent: "tontine" }
    : { name: "Sen Cagnotte", short: "SEN CAGNOTTE", logo: CAGNOTTE_LOGO, accent: "cagnotte" };
}

export default function ModeSwitcher({ className = "" }) {
  const location = useLocation();
  const isTontine = isTontineRoute(location.pathname);

  return (
    <div
      className={`inline-flex p-1 rounded-full border bg-secondary/40 ${className}`}
      role="tablist"
      data-testid="mode-switcher"
    >
      <Link
        to="/"
        data-testid="mode-cagnottes"
        role="tab"
        aria-selected={!isTontine}
        className={`flex items-center gap-1.5 px-3 sm:px-4 py-1.5 rounded-full text-xs sm:text-sm font-semibold transition-all ${
          !isTontine
            ? "bg-white dark:bg-zinc-900 text-foreground shadow-sm"
            : "text-muted-foreground hover:text-foreground"
        }`}
      >
        <Heart className="h-3.5 w-3.5" />
        <span>Cagnottes</span>
      </Link>
      <Link
        to="/tontines"
        data-testid="mode-tontines"
        role="tab"
        aria-selected={isTontine}
        className={`flex items-center gap-1.5 px-3 sm:px-4 py-1.5 rounded-full text-xs sm:text-sm font-semibold transition-all ${
          isTontine
            ? "bg-white dark:bg-zinc-900 text-foreground shadow-sm"
            : "text-muted-foreground hover:text-foreground"
        }`}
      >
        <Users className="h-3.5 w-3.5" />
        <span>Tontines</span>
      </Link>
    </div>
  );
}
